import { render, staticRenderFns } from "./testAttendance.vue?vue&type=template&id=50fd23db&scoped=true&"
import script from "./testAttendance.vue?vue&type=script&lang=js&"
export * from "./testAttendance.vue?vue&type=script&lang=js&"
import style0 from "./testAttendance.vue?vue&type=style&index=0&id=50fd23db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd23db",
  null
  
)

export default component.exports